module.exports = __webpack_public_path__ + "img/images-1.e893359c.jpg";